// extracted by mini-css-extract-plugin
export default {"wrapper":"V54pOJV1rlTNDBedXmKX","curvedIcon":"qg9jVi3GkcWjv51NyDJi","iconFolder":"tB_QEJm4Qm5hSLJux1xa","yellow":"twb3FyffzAoWMEegN3re","empty":"fzKvmjgRGOuI4l8NjG1y"};